import { render, staticRenderFns } from "./Mainmenu.vue?vue&type=template&id=4b77968c&scoped=true"
import script from "./Mainmenu.vue?vue&type=script&lang=js"
export * from "./Mainmenu.vue?vue&type=script&lang=js"
import style0 from "./Mainmenu.vue?vue&type=style&index=0&id=4b77968c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b77968c",
  null
  
)

export default component.exports